import { render, staticRenderFns } from "./AsidePage.vue?vue&type=template&id=02e31488"
import script from "./AsidePage.vue?vue&type=script&lang=js"
export * from "./AsidePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports